import common from '@/services/common'

export default {
    async startClientForGamePk(gamePk) {
        const url = "/api/gumbotopubsub/v1/listen"
        const data = { "gamePk" : String(gamePk) }
        return common.execute('post', url, data)
    },
    async getClientStatuses() {
        const url = "/api/gumbotopubsub/v1/clientStatuses"
        return common.execute('get', url)
    },
    async startAllSockets(date, timeZone) {
        const dateQuery = date ? '&date=' + date : ''
        const url = `/api/gumbowebsocketstarter/v1/startAllSockets?timeZone=${timeZone}${dateQuery}`
        return common.execute('get', url)
    },
    async getSchedule(date, timeZone) {
        const dateQuery = date ? '&date=' + date : ''
        const url = `${process.env.VUE_APP_STATS_API_BASE_URL}/api/v1/schedule/?sportId=1&fields=dates,date,games,gamePk,status,abstractGameState,teams,away,team,id,name,home&timeZone=${timeZone}${dateQuery}`
        return common.executeExternal('get', url)
    },
}